import axios from 'axios';
import { URL_DASHBOARD } from './config';

export async function getDashboard() {
    const result = await axios.get(URL_DASHBOARD);
    return result.data.data.data[0];
};
